export default __webpack_public_path__ + "static/media/placeholder_business03-it-web.bd90b150.png";